module.exports = __webpack_public_path__ + "assets/img/planning-item-2.8eb0d346.svg";